import { useTranslation } from "react-i18next";
import SupportUs from "components/supportUs";
import config from "utils/globals";

const UserInfo = ({ data }) => {
  const { t } = useTranslation();

  const renderInfoList = (infos) => {
    return (
      <div className="bg-gray--13 rounded-lg border border-gray--8 p-1">
        <div className="bg-white rounded-lg p-4 flex flex-col space-y-4">
          {infos?.map((item) => (
            <div className="flex justify-between body-14px-medium border-b border-gray--8 last:border-none pb-4 last:pb-0">
              <span className="text-gray-0 flex">
                <img src={item.icon} alt="icon" className="ml-2" />
                {item.label}:
              </span>
              <span>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderInfo = () => {
    return config.sortArray(data?.page_info, "priority")?.map((item) => {
      return (
        <>
          <span className="text-gray-4 body-14px-demibold">{item.title}</span>
          <span className="text-gray-0 body-14px-regular mb-3">
            {item.description}
          </span>
          {renderInfoList(item?.infos)}
        </>
      );
    });
  };

  return (
    <div className="mx-5 flex flex-col mb-24">
      {renderInfo()}
      <SupportUs />
    </div>
  );
};
export default UserInfo;
